import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} fill="none" {...props}>
    <path fill="#fff" d="M0 3.359V12h16V3.358l-8 5z" />
    <path fill="#fff" d="M16 1V0H0v1l8 5z" />
  </svg>
);
export default SvgSendIcon;
